import { backendUrl } from "../backendUrl";
import React, { useEffect, useState } from "react";
import { useDialogs } from "../DialogContext";
import logo3 from "./3.png";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
// import { apiServer } removed

import LoadingPage from "../LoadingPage";

import { Door, Key, Permission, Props, Mongo } from "../1/types";
import "./responsive.css";
import DoorsTable from "./components/DoorsTable";
import KeysTable from "./components/KeysTable";
import SummaryTotals from "./components/SummaryTotals";
import CommentBox from "./components/CommentBox";

interface ConfigurationDetailed {
  supllier: string;
  model: string;
  doors: Door[];
  keys: Key[];
  sumBrutto: number;
  sumNetto: number;
  tax: number;
  taxRate: number;
}

interface LockType {
  id: number;
  type_code: string;
  name: string;
  icon_path: string | null;
  display_order: number;
  is_active: number | boolean;
}

interface Supplier {
  id: number;
  name: string;
  icon_path: string;
  display_order: number;
  is_active: number;
}

const SpecialOptions = (props: Props) => {
  // K1: komunikat w stronie zamiast systemowego alert
  const { notify } = useDialogs();
  const navigate = useNavigate();

  const getStoredData = (key: string, defaultValue: any) => {
    const storedData = localStorage.getItem(key);
    return storedData ? JSON.parse(storedData) : defaultValue;
  };
  const getDataFromSession = getStoredData;
  const storeData = (key: string, data: any) => localStorage.setItem(key, JSON.stringify(data));

  const [pageIsLoaded, setPageIsLoaded] = useState<boolean>(false);
  const [configurationDetailed, setConfigurationDetailed] = useState<ConfigurationDetailed>();
  const [lockTypes, setLockTypes] = useState<LockType[]>([]);
  const [supplierIconMap, setSupplierIconMap] = useState<Record<string, string>>({});
  const [permission, setPermission] = useState<Permission[]>(
    getStoredData("permission", [
      { id: 1, idKey: 1, idDoor: 1, allow: true },
      { id: 2, idKey: 2, idDoor: 2, allow: true },
      { id: 3, idKey: 3, idDoor: 3, allow: true },
    ])
  );
  const [doors, setDoors] = useState<Door[]>(
    getDataFromSession("doors", [
      { id: 1, doorName: "Tür 1", lockAmount: 1, lockType: "N+G", lockOutside: 31, lockInside: 31 },
    ])
  );
  const [keys, setKeys] = useState<Key[]>(
    getDataFromSession("keys", [
      { id: 1, keyName: "Schlüssel 1", amount: 1 },
    ])
  );
  const supllier = getDataFromSession("supllier", []);
  const model = getDataFromSession("system1", []);
  const [comment, setComment] = useState<string>(getDataFromSession("comment", ""));

  useEffect(() => {
    storeData("doors", doors);
    storeData("keys", keys);
    storeData("permission", permission);

    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${backendUrl}/api/v1/configurator/configurationDetailed`,
          [{ supllier, model, doors, keys, comment }]
        );
        if (response.data.model.length === 0) navigate("/2");
        setConfigurationDetailed(response.data);
      } catch (e) {
        console.error("Błąd podczas pobierania danych:", e);
      } finally {
        setPageIsLoaded(true);
      }
    };
    fetchData();
  }, [doors, keys, permission, comment, supllier, model, navigate]);

  useEffect(() => {
    const fetchLockTypes = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/v1/configurator/lock-types`);
        // Filtruj tylko aktywne typy i posortuj po display_order
        const activeLockTypes = response.data
          .filter((lt: LockType) => lt.is_active)
          .sort((a: LockType, b: LockType) => a.display_order - b.display_order);
        setLockTypes(activeLockTypes);
      } catch (error) {
        console.error("Error fetching lock types:", error);
      }
    };
    fetchLockTypes();
    // backendUrl to stała modułu - efekt i tak działał tylko raz
  }, []);

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/v1/configurator/suppliers/active`);
        if (response && response.data) {
          const iconMap: Record<string, string> = {};
          response.data.forEach((supplier: Supplier) => {
            iconMap[supplier.name] = supplier.icon_path;
          });
          setSupplierIconMap(iconMap);
        }
      } catch (error) {
        console.error("Błąd podczas pobierania dostawców:", error);
      }
    };
    fetchSuppliers();
  }, []);

  const saveToDB = () => {
    const permissionLS = getDataFromSession("permission", []);
    const data: Mongo = {
      supllier,
      model,
      doors,
      keys,
      opensDoor: permissionLS,
      comment,
      netto: configurationDetailed?.sumNetto,
      brutto: configurationDetailed?.sumBrutto,
    };
    (async () => {
      try {
        const response = await axios.post(`${backendUrl}/api/v1/configurator/mongo`, [data]);
        localStorage.setItem("mongoID", response.data);
      } catch (e) {
        console.error("Błąd podczas zapisu danych:", e);
      }
    })();
  };

  // downloadExcel usunięty jako nieużywany (można przywrócić z historii jeśli potrzebny)

  const findDoor = (doorName: string) => doors.find(d => d.doorName === doorName);
  const findKey = (keyName: string) => keys.find(k => k.keyName === keyName);

  const handleDoorChange = (index: number, field: keyof Door, value: string | number) => {
    if (String(value) === "NaN") value = 0;
    const updated = [...doors];
    updated[index][field] = value as never;
    setDoors(updated);
  };
  const handleInputChangeAmont = (index: number, value: number, field: string, step: number) => {
    if (field === "lockAmount") {
      if ((step >= 0 && value >= 0) || (value > 0 && step <= 0)) {
        const updated = [...doors];
        updated[index].lockAmount = value + step;
        setDoors(updated);
      }
    } else if (field === "amount") {
      if ((step >= 0 && value >= 0) || (value > 0 && step <= 0)) {
        const updated = [...keys];
        updated[index].amount = value + step;
        setKeys(updated);
      }
    }
  };
  const handleInputChange = (
    index: number,
    field: keyof Door,
    value: string | number,
    numb: number,
    step: number,
    name: string,
    innen: number,
    auben: number
  ) => {
    let dozmiany = numb + step;
    if (dozmiany === 26) dozmiany = 27;
    if (dozmiany === 37 || dozmiany === 36) dozmiany = 35;
    if (dozmiany === 30) dozmiany = name === "HPZ" ? 32 : 31;
    if (dozmiany > 120) return;
    if (dozmiany < 30 && (auben === 27 || innen === 27)) return;
    if (name !== "HPZ" && dozmiany === 32) dozmiany = 31;
    if (dozmiany < 27) return;
    const updated = [...doors];
    updated[index][field] = value as never;
    if (field === "lockOutside" || field === "lockInside") {
      updated[index][field] = (parseInt(updated[index][field].toString(), 10) || 0) + dozmiany;
    }
    setDoors(updated);
  };

  const updateIdsAfterRemoval = (items: any[], removedIndex: number) => items.map(it => it.id > removedIndex ? { ...it, id: it.id - 1 } : it);
  const updatePermissionIds = (perm: any[], removedIndex: number, idField: string) => perm.map(p => p[idField] > removedIndex ? { ...p, [idField]: p[idField] - 1 } : p);
  const handleRemoveItem = (
    index: number,
    items: any[],
    setItems: (v: any[]) => void,
    perm: any[],
    setPerm: (v: any[]) => void,
    idField: string
  ) => {
    if (items.length <= 1) { notify("Es ist nicht möglich, alle Elemente zu entfernen.", "info"); return; }
    let updatedItems = items.filter(i => i.id !== index);
    updatedItems = updateIdsAfterRemoval(updatedItems, index);
    let updatedPerm = perm.filter(p => p[idField] !== index);
    updatedPerm = updatePermissionIds(updatedPerm, index, idField);
    setPerm(updatedPerm);
    setItems(updatedItems);
  };
  const handleRemoveKeyx = (index: number) => handleRemoveItem(index, keys, setKeys, permission, setPermission, "idKey");
  const handleRemoveDoorx = (index: number) => handleRemoveItem(index, doors, setDoors, permission, setPermission, "idDoor");

  // Get supplier icon path from database or fallback to hardcoded path
  const getSupplierIcon = () => {
    if (!configurationDetailed?.supllier) return '';
    const iconPath = supplierIconMap[configurationDetailed.supllier];
    if (iconPath) {
      return `${backendUrl}${iconPath}`;
    }
    // Fallback to old hardcoded path if not in database
    return `${backendUrl}/img/${configurationDetailed.supllier.trim()}.jpeg`;
  };

  return (
    <div id="special-options" className={props.disabled ? "special-options" : "special-options special-options--page"} style={{ width: "75%", margin: "65px auto" }}>
      <div style={{ textAlign: "left", margin: "20px 0", padding: "1rem", display: props.disabled ? "none" : "block" }}>
        <p style={{ fontSize: "1.2rem", fontWeight: 800, display: "flex", alignItems: "center" }}>
          <img src={logo3} alt="Tytuł" style={{ width: "1.2rem", marginRight: "0.3rem" }} />
          Zusammenfassung
        </p>
        <p style={{ fontSize: "0.95rem", color: "#555", marginTop: "0.25rem" }}>Für die gewählte Schließanlage {configurationDetailed?.supllier} {configurationDetailed?.model}</p>
      </div>
      <hr />
      {pageIsLoaded ? (
        <div>
          <div className="system-brand-row" style={{ width: "100%", display: "flex", justifyContent: "space-around", padding: "20px" }}>
            <div style={{ width: "100%", color: "black", display: "flex", alignItems: "center" }} className="is-size-6 has-text-weight-bold system-brand-inner">
              <img style={{ width: "70px", height: "40px", float: "left", marginRight: "10px" }} src={getSupplierIcon()} alt="logo" />
              <div>{configurationDetailed?.supllier} {configurationDetailed?.model}</div>
              <div className="system-hinweis" style={{ textAlign: "right", fontSize: "0.85rem", marginLeft: "auto" }}>
                <p style={{ margin: 0 }}><strong>Hinweis: </strong>Registrierte Profikunden erhalten bei Bestellung in der separaten Auftragsbestätigung ihre individuellen Nettopreise.</p>
              </div>
            </div>
          </div>
          <DoorsTable
            doors={configurationDetailed?.doors || []}
            disabled={props.disabled}
            backendUrl={backendUrl}
            findDoor={findDoor}
            handleRemoveDoorx={handleRemoveDoorx}
            handleInputChangeAmont={handleInputChangeAmont}
            handleDoorChange={handleDoorChange}
            handleInputChange={handleInputChange}
            lockTypes={lockTypes}
            taxRate={configurationDetailed?.taxRate}
          />
          <KeysTable
            keys={configurationDetailed?.keys || []}
            disabled={props.disabled}
            backendUrl={backendUrl}
            findKey={findKey}
            handleRemoveKeyx={handleRemoveKeyx}
            handleInputChangeAmont={handleInputChangeAmont}
            taxRate={configurationDetailed?.taxRate}
          />
          <div
            style={{
              display: "flex",
              gap: "20px",
              padding: "20px",
              alignItems: "flex-start",
              flexWrap: "nowrap",
            }}
            className="comment-summary"
          >
            <div style={{ flex: "0 0 30%", minWidth: "100px" }}>
              <CommentBox
                value={comment}
                disabled={props.disabled}
                onChange={(val) => { setComment(val); storeData("comment", val); }}
              />
            </div>
            <div style={{ flex: "0 0 70%", minWidth: "100px" }}>
              <SummaryTotals
                sumNetto={configurationDetailed?.sumNetto}
                sumBrutto={configurationDetailed?.sumBrutto}
                tax={configurationDetailed?.tax}
                taxRate={configurationDetailed?.taxRate}
              />
            </div>
          </div>
          <div className="LockConfiguratorButons" style={{ display: props.disabled ? "none" : "flex" }}>
            <Link to={"/2"}>
              <div className="LockConfiguratorButon button-secondary"><div className="text-wrapper1">Zurück</div></div>
            </Link>
            <Link to="/4" onClick={() => { saveToDB(); document.getElementById("navbar")?.scrollIntoView({ behavior: "smooth" }); }}>
              <div className="LockConfiguratorButon">
                <div className="text-wrapper">Zur Bestellung</div>
                <img className="vector" alt="Vector" src={`${backendUrl}/img/Vector.svg`} />
              </div>
            </Link>
          </div>
        </div>
      ) : <LoadingPage />}
    </div>
  );
};

export default SpecialOptions;
